<div class="container">

  <div class="d-flex gap-1">

    <mat-form-field appearance="outline">
      <mat-label>Centre Name</mat-label>
      <mat-select [formControl]="SelectCentre" (selectionChange)="onCentreChange($event)">
        <mat-option value="All">All Centres</mat-option>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Teacher</mat-label>
      <mat-select [(value)]="mTeacher">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let t of teachers$ | async" [value]="t.userName">
          {{ t.userName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <app-searchable-select
      class="col-md-3"
      [options]="_specialDay$ | async"
      [displayWithFn]="displaySpecialDay"
      [placeholder]="'Select Special Day'"
      [label]="'Select Special Day'"
      [selectedValue]="selectedSpecialDay"
      (selectedValueChange)="selectedSpecialDay = $event">  <!-- ← emit selection back -->
    </app-searchable-select>

    <mat-form-field appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="From date" [formControl]="startDate">
        <input matEndDate placeholder="To date" [formControl]="endDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button mat-mini-fab color="accent" (click)="search()">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab color="accent" (click)="clearAll()">
      <mat-icon>clear</mat-icon>
    </button>

  </div>

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Special day</h2>
      </li>

      <li class="dropdown m-l-20">
        <label><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)="applyFilter($event)" aria-label="Search box">
      </li>
    </ul>

    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab  class="mr-2" color="primary" (click)="addSpecialDay()" permission="Special Day" [permissionTypes]="[PermissionType.ADD, PermissionType.ALL]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
      <li class="me-2">
        <button
          mat-mini-fab
          color="accent"
          matTooltip="Download Excel"
          (click)="downloadExcel()" permission="Special Day" [permissionTypes]="[PermissionType.EXCEL, PermissionType.ALL]">
          <mat-icon>download</mat-icon>
        </button>
      </li>

    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <ng-container matColumnDef="srNo">
      <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
      <td mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let row"> {{ row.date?.toDate() | date }} </td>
    </ng-container>


    <ng-container matColumnDef="teacherName">
      <th mat-header-cell *matHeaderCellDef> Teacher </th>
      <td mat-cell *matCellDef="let row"> {{ row.teacherName }} </td>
    </ng-container>

    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef> Centre </th>
      <td mat-cell *matCellDef="let row"> {{ row.centreName }} </td>
    </ng-container>

    <ng-container matColumnDef="specialDay">
      <th mat-header-cell *matHeaderCellDef> Special day </th>
      <td mat-cell *matCellDef="let row"> {{ row.specialDay }} </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="accent"
                (click)="view(row)"
                permission="Special Day"
                [permissionTypes]="[PermissionType.VIEW, PermissionType.ALL]">
          <mat-icon>visibility</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="edit(row)"  permission="Special Day" [permissionTypes]="[PermissionType.EDIT]">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="delete(row.id)" permission="Special Day" [permissionTypes]="[PermissionType.ARCHIVE]">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
</div>
